import React from "react";
import { FirmDocumentFoldersStatistics } from "../../models/Statistics/FirmDocumentFoldersStatistics";
import StatisticsCard from "../common/StatisticsCard";
import { CHART_COLORS } from "../../constants/ChartColors";

interface FirmDocumentsStatisticsCardProps {
  statistics: FirmDocumentFoldersStatistics;
}

const FirmDocumentsStatisticsCard: React.FC<
  FirmDocumentsStatisticsCardProps
> = ({ statistics }) => {
  const caseChartData = [
    {
      name: "Migrated",
      value: statistics.foldersMigrated,
      color: CHART_COLORS.migrated,
    },
    {
      name: "In Progress",
      value: statistics.foldersInProgress,
      color: CHART_COLORS.inProgress,
    },
    {
      name: "Interrupted",
      value: statistics.foldersInterrupted,
      color: CHART_COLORS.interrupted,
    },
    {
      name: "Not Started",
      value:
        statistics.numberOfFolders -
        (statistics.foldersMigrated +
          statistics.foldersInterrupted +
          statistics.foldersInProgress +
          statistics.foldersFlagged),
      color: CHART_COLORS.notStarted,
    },
    {
      name: "Flagged",
      value: statistics.foldersFlagged,
      color: CHART_COLORS.flagged,
    },
  ];
  const filesChartData = [
    {
      name: "Migrated",
      value: statistics.filesMigrated,
      color: CHART_COLORS.migrated,
    },
    {
      name: "Not Found",
      value: statistics.filesNotFound,
      color: CHART_COLORS.inProgress,
    },
    {
      name: "Not Found (Marked For Retry)",
      value: statistics.filesNotFoundMarkedForRetry,
      color: CHART_COLORS.acknowledged,
    },
    {
      name: "Interrupted Initial",
      value: statistics.filesInterruptedInitial,
      color: CHART_COLORS.interrupted,
    },
    {
      name: "Interrupted Delta",
      value: statistics.filesInterruptedDelta,
      color: CHART_COLORS.interruptedDelta,
    },
    {
      name: "Modified",
      value: statistics.filesModified,
      color: CHART_COLORS.modified,
    },
    {
      name: "Not Started",
      value: Math.max(0,
        statistics.totalNumberOfFiles -
        (statistics.filesMigrated +
          statistics.filesInterruptedInitial +
          statistics.filesInterruptedDelta +
          statistics.filesModified +
          statistics.filesNotFound +
          statistics.filesNotFoundMarkedForRetry +
          statistics.filesFlagged +
          statistics.firmDocumentsUnresolvedConflictCount +
          statistics.firmDocumentsAcknowledgedConflictCount)),
      color: CHART_COLORS.notStarted,
    },
    {
      name: "Blocked by conflict",
      value: statistics.firmDocumentsUnresolvedConflictCount,
      color: CHART_COLORS.blockedByConflict,
    },
    {
      name: "Acknowledged conflict",
      value: statistics.firmDocumentsAcknowledgedConflictCount,
      color: CHART_COLORS.acknowledgedConflict,
    },
  ];
  const flagsChartData = [
    {
      name: "Blocked by user",
      value: statistics.documentsInFirmDocumentsFoldersBlockedByUser,
      color: CHART_COLORS.blockedByUser,
    }
  ];
  return (
    <StatisticsCard
      migrationChartData={{ data: caseChartData, label: "Firm Documents" }}
      filesChartData={{ data: filesChartData, label: "Files" }}
      fileFlagsChartData={{ data: flagsChartData, label: "Flags"}}
      title={"Firm Documents Statistics"}
      totalFilesSizeInGb={statistics.totalFilesSizeInGb}
      totalMigratedFilesSizeInGb={statistics.totalMigratedFilesSizeInGb}
      totalFilesSizeInMb={statistics.totalFilesSizeInMb}
      totalMigratedFilesSizeInMb={statistics.totalMigratedFilesSizeInMb}
      notFoundFilesSizeInGb={statistics.notFoundDocumentFilesSizeInGb || 0}
      notFoundFilesSizeInMb={statistics.notFoundDocumentFilesSizeInMb || 0}
      interruptedFilesSizeInGb={(statistics.interruptedInitialDocumentFilesSizeInGb || 0) + (statistics.interruptedDeltaDocumentFilesSizeInGb || 0)}
      interruptedFilesSizeInMb={(statistics.interruptedInitialDocumentFilesSizeInMb || 0) + (statistics.interruptedDeltaDocumentFilesSizeInMb || 0)}
      showFlaggedSizeInfo={false}
    />
  );
};

export default FirmDocumentsStatisticsCard;
